var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 90,
    height: 90,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1456_399",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1456_399",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByklEQVR4nO3cTWrCQBjG8QcXgnoDr+CleoraG9Ru+4HuPJU3qO2u7aIWXE0JTKEEh+mMyTtT8//BuwlB42OYQPIQCQAAAAAAYNjGku4kvUhyibOXtPKfgYhVRsCuNc1nICLnTHateSXlONfRIIKgjRB04aCPkq4lzf0s/TaXuHRMJT1J+ujwT+1q3iU9SpqUDLoJtm2ZEfSmgkBj0xxj70Jf3pzFbfPEoEeSvioIMjYHf6y9ImiVDfrU0nFzoUvHWgZCX370YZ97MZxIevAXHlfZvEm6L30xTB1EELQRgjay7yDsZ6uDHfpt0tvSP+I/GPuwc87sPTf+AQAAakOvwwi9DiP0OoxwU8kIQRsh6EqC3vrJfcIypdcRD3onaeZnlxn0pvBzwep7HZ+SFr/2W/htLiFoeh1/CPrqRHDNNkfQ3Z3RzZocsr3ApaNIr+NnXQ6ZBdbrEHodgaBzBxEEbYSgjdDrMEKvwwi9DgAAgItCr8MIvQ4j9DqMcFPJCEEbIWgjqU9MXOL+9DqMgt5U8PC16l5HF/uPeF8HQbta3tcxpKVj3UOuZwfnEven1xEJLnUQQdBGCNoIvQ4j9DqM0OsAAAAAAADQsH0DPmovsniAJU8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.95d1fbf638a0c52c95dddd2f4e6f0d21.svg";
export { ForwardRef as ReactComponent };